import { frontendURL } from '../../../../helper/URLHelper';

// Automation rules now live under Automations > Internal; keep old links working.
const redirect = to => ({ name: 'automations_rules', params: to.params });

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation'),
      redirect,
    },
    {
      path: frontendURL('accounts/:accountId/settings/automation/list'),
      redirect,
    },
  ],
};
